// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_vjkZu","menu_w1000":"index_menu_w1000_45cBQ","logo":"index_logo_igAKy","menu_r":"index_menu_r_oXsrJ","active":"index_active_di3t8"};